module.exports = [{"id":"5106404","apiRef":31,"title":"פעם עשו פה פופ קשוח","videoId":"184370"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/articles.json
// module id = 213
// module chunks = 0